'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInformationsStateFromNewProps = undefined;
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _ = require('../');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var initialState = {
  dataflow: null,
  dataflowAttributes: null,
  dimensions: null,
  units: null,
  id: null,
  sourceLabel: null,
  subtitle: null,
  title: null,
  withCopyright: true,
  withLogo: true
};
var getInformationsStateFromNewProps = exports.getInformationsStateFromNewProps = function getInformationsStateFromNewProps(props, state) {
  if (R.isNil(props.data)) {
    return initialState;
  }
  var id = R.pipe(R.prop('data'), _.extractSdmxArtefacts, R.prop('id'))(props);
  if (id === state.id && props.display === state.display) {
    return {};
  }
  var _prepareData = (0, _.prepareData)({
      data: props.data
    }, props.customAttributes, props.units),
    dataflowAttributes = _prepareData.dataflowAttributes,
    dataflowName = _prepareData.dataflowName,
    dimensions = _prepareData.dimensions,
    units = _prepareData.units;
  return (0, _extends3.default)({}, initialState, {
    dataflow: {
      id: props.dataflowId,
      name: dataflowName
    },
    dataflowAttributes: dataflowAttributes,
    dimensions: dimensions,
    display: props.display,
    id: id,
    units: units
  });
};